export enum SharingType {
    Owner = 0,
    EquallyOwn = 1,
    ViewAndEdit = 2,
    ViewOnly = 3
}